import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
gsap.registerPlugin(SplitText);

export default function initAppearAnim() {
    const $appearAnimElements = document.querySelectorAll('.anim-element');

    $appearAnimElements.forEach($element => {
        new AppearAnim($element);
    });
}

class AppearAnim {
    $element: Element;
    gsapAnimationDone: boolean = false;
    splitText: SplitText | null = null;
    observer: IntersectionObserver | null = null;
    fontsLoaded: boolean = false;

    constructor($element: Element) {
        this.$element = $element;
        this.onIntersection = this.onIntersection.bind(this);
        this.waitForFonts();
    }

    async waitForFonts() {
        // Attendre que les polices soient chargées
        if (document.fonts && document.fonts.ready) {
            await document.fonts.ready;
        }
        this.fontsLoaded = true;
        this.prepareTitle();

        // Créer l'observer seulement après la préparation
        this.observer = new IntersectionObserver(this.onIntersection, {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        });
        this.observer.observe(this.$element);

        // Si déjà visible, lancer l'animation tout de suite
        if (this.isElementInViewport(this.$element)) {
            this.$element.classList.add('appear');
            this.revealTitle();
            if (this.observer) {
                this.observer.unobserve(this.$element);
            }
        }
    }

    isElementInViewport(el: Element) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top < window.innerHeight &&
            rect.bottom > 0
        );
    }

    prepareTitle() {
        if (!this.fontsLoaded) return;

        const $title = this.$element.querySelector('.title-anim');
        if ($title && !this.splitText) {
            this.splitText = new SplitText($title, {
                type: 'words',
            });

            gsap.set(this.splitText.words, {
                opacity: 0,
                y: 30,
            });
        }
    }

    onIntersection(entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            if (entry.isIntersecting && !this.gsapAnimationDone) {
                this.$element.classList.add('appear');
                this.revealTitle();
                if (this.observer) {
                    this.observer.unobserve(this.$element);
                }
            }
        });
    }

    revealTitle() {
        if (this.splitText && !this.gsapAnimationDone && this.fontsLoaded) {
            this.gsapAnimationDone = true;

            gsap.to(this.splitText.words, {
                duration: 0.8,
                stagger: 0.08,
                opacity: 1,
                y: 0,
                ease: "power2.out",
                onComplete: () => {
                    if (this.splitText) {
                        this.splitText.revert();
                    }
                }
            });
        }
    }
}